function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Container, Form, Input, Button, Message, Menu, Dropdown } from 'semantic-ui-react';
import ContextMenu from '../components/ContextMenu';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import URLSearchParams from 'url-search-params';
import { getProductUrl } from '../helpers';
import { loadNoAccessTeams } from '../actions/teams/loadNoAccessTeams';
import { switchOrganisationAndTeam } from '../actions/authentication/switchOrganisationAndTeam';

var NoAccess = function (_React$Component) {
  _inherits(NoAccess, _React$Component);

  function NoAccess() {
    _classCallCheck(this, NoAccess);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.currentNoAccessOrganisation = function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        currentOrganisationValue: value
      });

      _this.setState({
        currentNoAccessOrganisation: value
      });

      _this.props.loadNoAccessTeams(value);
    };

    _this.currentNoAccessTeam = function (e, _ref2) {
      var value = _ref2.value;

      _this.setState({
        currentTeanValue: value
      });

      _this.setState({
        currentNoAccessTeam: value
      });
    };

    _this.setCurrentOrganisationAndTeam = function (currentNoAccessOrganisation, currentNoAccessTeam) {
      _this.props.switchOrganisationAndTeam(currentNoAccessOrganisation, currentNoAccessTeam);

      window.location.href = '/';
    };

    _this.state = {
      currentNoAccessOrganisation: null,
      currentNoAccessTeam: null
    };
    return _this;
  }

  NoAccess.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        error = _props.error,
        _props$products = _props.products,
        products = _props$products === undefined ? [] : _props$products,
        _props$organisations = _props.organisations,
        organisations = _props$organisations === undefined ? [] : _props$organisations,
        teams = _props.teams,
        noAccessOrganisationChange = _props.noAccessOrganisationChange,
        loadNoAccessTeams = _props.loadNoAccessTeams,
        currentOrganisation = _props.currentOrganisation,
        currentTeam = _props.currentTeam,
        switchOrganisationAndTeam = _props.switchOrganisationAndTeam,
        productName = _props.productName;
    var currentNoAccessOrganisation = this.state.currentNoAccessOrganisation;
    var currentNoAccessTeam = this.state.currentNoAccessTeam;
    var organisationOptions = [];
    var teamOptions = [];
    var currentOrganisationValue = this.state.currentOrganisationValue;
    var currentTeamValue = this.state.currentTeamValue;
    organisations.forEach(function (organisation) {
      organisationOptions.push({
        value: organisation.id.toString(),
        key: organisation.id.toString(),
        text: organisation.name
      });
    });
    teams.forEach(function (team) {
      teamOptions.push({
        value: team.id.toString(),
        key: team.id.toString(),
        text: team.name
      });
    });
    var dropdownStyle = {
      maxWidth: '300px',
      margin: '0 auto',
      marginBottom: '20px',
      lineHeight: '12px'
    };
    var mainHeader = {
      fontFamily: "'Proxima Nova',sans-serif",
      fontSize: '30px',
      fontWeight: '100',
      textAlign: 'center'
    };
    var subHeader = {
      fontFamily: "'Proxima Nova',sans-serif",
      fontSize: '20px',
      fontWeight: '400',
      textAlign: 'center'
    };
    var label = {
      fontWeight: '600',
      justifyContent: 'center',
      color: '#0f849e',
      fontSize: '18px',
      textAlign: 'center'
    };
    var productLabel = {
      fontSize: '12px'
    };
    var nineDotMenuItem = {
      width: '50px',
      height: '50px'
    };
    var nineDotMenuImage = {
      width: '29px',
      height: '29px'
    };
    var buttonStyle = {
      margin: '0 auto',
      display: 'block'
    };
    return React.createElement('div', {
      className: 'page--multifaceted-bg-grey'
    }, React.createElement(Container, {
      className: 'page-container'
    }, React.createElement('div', {
      className: 'register-form'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 10
    }, React.createElement('div', {
      className: 'callout'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Row, null, products.map(function (product) {
      var className = 'nine-dot__item';

      if (!product.hasAccess) {
        return React.createElement('span', null);
      }

      return React.createElement(Grid.Column, {
        key: product.id
      }, React.createElement('a', {
        className: className,
        href: product.url,
        target: '_blank'
      }, React.createElement('div', {
        className: 'nine-dot-menu__icon',
        style: nineDotMenuItem
      }, React.createElement('img', {
        src: product.iconLogoLocation,
        alt: product.name,
        style: nineDotMenuImage
      })), React.createElement('span', {
        style: productLabel
      }, product.name)));
    })))))))));
  };

  return NoAccess;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.user.error,
    products: state.auth.products,
    organisations: Object.values(state.auth.organisations.byId),
    teams: state.auth.organisations.currentOrganisation && state.auth.teams.noAccessTeams && state.auth.teams.noAccessTeams.byId ? Object.values(state.auth.teams.noAccessTeams.byId) : [],
    currentOrganisation: Object.values(state.auth.organisations.byId).filter(function (data) {
      return data.id == state.auth.organisations.currentOrganisation;
    })[0],
    currentTeam: Object.values(state.auth.teams.byId).filter(function (data) {
      return data.id == state.auth.teams.currentTeam;
    })[0],
    currentNoAccessOrganisation: state.currentNoAccessOrganisation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loadNoAccessTeams: loadNoAccessTeams,
    switchOrganisationAndTeam: switchOrganisationAndTeam
  }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoAccess));
/*

- get current organisations who have access to this product
- get products this organisdation has access too

*/